import { StoreAvailabilityDataSourceEnum, ZipAvailabilityDataSourceEnum } from '@inter-ikea-kompis/enums';
import { ServiceException } from '@inter-ikea-kompis/exceptions';
import DexfStoreAvailabilityService from '../../services/store-availability/DexfStoreAvailabilityService.js';
import DexfZipAvailabilityService from '../../services/zip-availability/DexfZipAvailabilityService.js';
import DexfConfiguration from '../../utilities/DexfConfiguration.js';
/**
 * This class is used as a simple interface for store availability services.
 */
export default class CheckoutAvailabilityService {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    constructor(options) {
        this.dexfConfiguration = new DexfConfiguration(options);
    }
    /**
     * Fetches and returns zip code availability.
     *
     * @param zip Zip Code.
     * @param items Items.
     * @returns Promise.
     */
    async getZipAvailabilities(zip, items) {
        const service = await this.getZipAvailabilityService();
        return await service.getZipAvailabilities(zip, items);
    }
    /**
     * Fetches and returns store availability.
     *
     * @param storeId Store id.
     * @param items Items.
     * @returns Promise.
     */
    async getStoreAvailabilities(storeId, items) {
        const service = await this.getStoreAvailabilityService();
        return await service.getStoreAvailabilities(storeId, items);
    }
    /**
     * Returns DEXF service if the zipAvailabilityDataSource setting
     * for the locale is not set to 'disabled'.
     *
     * @returns Service | null.
     */
    async getZipAvailabilityService() {
        const settings = await this.dexfConfiguration.getSettings();
        const dexfApiKey = await this.dexfConfiguration.getDexfApiKeyOrThrow();
        switch (settings.kompis.serviceSettings.zipAvailabilityDataSource) {
            case ZipAvailabilityDataSourceEnum.disabled:
                throw new ServiceException('The zipAvailabilityDataSource is set to "disabled" in the localized information. When it is, the ZipAvailabilityService is not available on the market.');
            default:
                return new DexfZipAvailabilityService({
                    endpoint: settings.kompis.endpoints.dexfZipAvailabilityService,
                    dexfApiKey: dexfApiKey
                });
        }
    }
    /**
     * Returns DEXF service if the storeAvailabilityDataSource setting
     * for the locale is not set to 'disabled'.
     *
     * @returns Service | null.
     */
    async getStoreAvailabilityService() {
        const settings = await this.dexfConfiguration.getSettings();
        const dexfApiKey = await this.dexfConfiguration.getDexfApiKeyOrThrow();
        switch (settings.kompis.serviceSettings.storeAvailabilityDataSource) {
            case StoreAvailabilityDataSourceEnum.disabled:
                throw new ServiceException('The storeAvailabilityDataSource is set to "disabled" in the localized information. When it is, the StoreAvailabilityService is not available on the market.');
            default:
                return new DexfStoreAvailabilityService({
                    endpoint: settings.kompis.endpoints.dexfStoreAvailabilityService,
                    dexfApiKey: dexfApiKey
                });
        }
    }
}
//# sourceMappingURL=CheckoutAvailabilityService.js.map